import { Cards } from '../components/Cards';
import { HeroSection } from '../components/HeroSection';

export const Home = () => {
  return (
    <>
      <HeroSection />
      <Cards />
    </>
  );
};
